import { PlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { Facing } from "./Facing";
import { ThreePlanogram } from "../store/types";

interface ItemProps {
  product: PlanogramItem;
  three: ThreePlanogram;
}

export const Product = ({ product: item, three }: ItemProps) => {
  const coordinates = item.getCoordinates();
  const shelfDepth = item.shelf.depth;

  const totalFacings = item.facings || 1;
  const rows = item.facingsRows || 1;
  const columns = Math.ceil(totalFacings / rows);

  const depthRepeats = Math.floor(shelfDepth / item.getDepth());
  const freeSpace = shelfDepth - depthRepeats * item.getDepth();

  return (
    <>
      {Array.from({ length: totalFacings }).flatMap((_, index) => {
        const row = Math.floor(index / columns);
        const col = index % columns;

        return Array.from({ length: depthRepeats }).map((_, zIndex) => (
          <Facing
            key={`${index}-${zIndex}`}
            three={three}
            x={coordinates.xLeft + item.getWidth() * col}
            y={coordinates.yBottom + item.getHeight() * row}
            z={freeSpace + item.getDepth() * zIndex}
            item={item}
          />
        ));
      })}
    </>
  );
};
